const user = {
  labels: {
    surname: "Фамилия",
    name: "Имя",
    patronymic: "Отчество",
    password: "Пароль",
    workplace: "Рабочее место",
    role_id: null,
  },
  maxLength: {
    surname: 180,
    name: 180,
    workplace: 80,
    patronymic: 180,
    password: 32,
    role_id: 1,
  },
};

const passport = {
  labels: {
    date_of_birth: "Дата рождения",
    place_of_birth: "Место рождения",
    registration_address: "Адрес регистрации",
    number: "Номер паспорта",
    series: "Серия паспорта",
    obtaining_passport_place: "Место выдачи паспорта",
    obtaining_passport_date: "Дата выдачи паспорта",
  },
  maxLength: {
    date_of_birth: 90,
    place_of_birth: 150,
    registration_address: 150,
    number: 90,
    series: 90,
    obtaining_passport_place: 180,
    obtaining_passport_date: 60,
  },
  inputTypes: {
    date_of_birth: "date",
    place_of_birty: "text",
    registration_address: "text",
    number: "text",
    series: "text",
    obtaining_passport_place: "text",
    obtaining_passport_date: "date",
  },
};

const shiftsCalendar = {
  labels: {
    name: 'Название',
    description: 'Дополнительное описание',
    dates: 'Даты календаря',
    times: 'Время смен',
    users: 'Пользователи, работающие по календарю',
  },
  maxLength: {
    name: 160,
    description: 160,
  },
};

const achievement = {
  labels: {
    name: 'Название',
    description: 'Короткое описание',
    receipt_condition: 'Условие получения',
    users: "Пользователи",
    icon_background: 'Цвет иконки',
    icon_name: 'Цвет иконки',
  },
  maxLength: {
    name: 80,
    description: 200,
    receipt_condition: 200,
  },
};

export const formsFields = {
  user,
  passport,
  shiftsCalendar,
  achievement,
};



// WEBPACK FOOTER //
// ./src/user/constants/formsFields.js